export default function AnthropicIcon() {
  return (
    <img
      src="https://app.vectorshift.ai/anthropic-logo.png"
      alt="Anthropic"
      width={16}
      height={16}
    />
  );
}
